import React from 'react';
import PropTypes from 'prop-types';
import Header from './header/';
import LivingSlide from './livingSlide/';
import errorBoundary from '@ifeng/errorBoundary';

class Layout extends React.PureComponent {
    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    /**
     * 渲染网页布局
     */
    render() {
        const { content } = this.props;
        const { docData, slideData, footer, recommendData } = content;

        return (
            <div>
                <Header docData={docData} />
                <LivingSlide slideData={slideData} docData={docData} footer={footer} recommendData={recommendData} />
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
Layout.propTypes = { content: PropTypes.object };

/**
 * 定义组件默认属性
 * */
Layout.defaultProps = {};

export { Layout };
export default errorBoundary(Layout);
